document.addEventListener('DOMContentLoaded', () => {
    const sidebar = document.getElementById('sidebar');
    const toggleBtn = document.getElementById('js-sidebar-toggle');

    // 1. Verify both elements exist before doing anything
    if (!sidebar || !toggleBtn) {
        console.error("Sidebar or Toggle Button missing from the DOM!", { sidebar, toggleBtn });
        return;
    }

    // 2. Immediately apply the saved state on load
    const savedState = localStorage.getItem('sidebarState');
    if (savedState === 'collapsed') {
        sidebar.classList.add('collapsed');
    } else if (savedState === 'expanded') {
        sidebar.classList.remove('collapsed');
    }

    // 3. Listen for the toggle click
    toggleBtn.addEventListener('click', () => {
        sidebar.classList.toggle('collapsed');

        // 4. Save the new state based on the class presence
        if (sidebar.classList.contains('collapsed')) {
            localStorage.setItem('sidebarState', 'collapsed');
        } else {
            localStorage.setItem('sidebarState', 'expanded');
        }
    });
});
